module.exports = __webpack_public_path__ + "img/level1_mining_hands_shadow.73a67881.png";